export const columns = [
    {
        field: 'id',
        header: 'Id',
        sizes: { xs: 1 }
    },
    {
        header: 'Razon Social',
        translate: (customer) => `${customer.firstName} ${customer.lastName ?? ''}`,
        sizes: { xs: 2 }
    },
    {
        field: 'email',
        header: 'Email',
        sizes: { xs: 2 }
    },
    {
        header: 'Tipo y Nro. Documento',
        translate: (customer) => `${customer.documentType} ${customer.documentNumber}`,
        sizes: { xs: 2 }
    },
    {
        field: 'taxCondition',
        header: 'Condición',
        translate: (taxCondition) => TaxConditionsTranslate[taxCondition]
    },
    {
        field: 'active',
        header: 'Activo',
        type: 'boolean'
    },
    {
        field: 'created',
        header: 'Creado',
        type: 'date'
    }
]

export const title = 'Clientes';
export const customerModel = {
    id: null,
    firstName: '',
    lastName: '',
    email: '',
    gender: null,
    documentType: '',
    documentNumber: '',
    phone: '',
    country: null,
    taxCondition:'FinalConsumer',
    created: null,
    updated: null,
    addresses: [],
    activeNewsletter: false,
    active: true
};

export const countriesTranslate = {
    AR: 'Argentina',
    UY: 'Uruguay',
}

export const TaxConditionsTranslate = {
    FinalConsumer: 'Consumidor Final',
    RegisteredManager: 'Responsable inscripto',
    Exempt: 'Exento',
    SingleTaxSystemPayer: 'Monotributista',
    ExteriorClient: 'Cliente exterior'
}

export const genderTranslate = {
    Male: 'Masculino',
    Female: 'Femenino',
    Other: 'Otro',
}

export const gender = [
    { value: 'Male', label: 'Masculino' },
    { value: 'Female', label: 'Femenino' },
    { value: 'Other', label: 'Otro' },
];


